/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Fra8Inputs */

const en__field_enum_icsrm_fra8 = /** @type {(inputs: _Field_Enum_Icsrm_Fra8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt University of Applied Sciences`)
};

const de__field_enum_icsrm_fra8 = /** @type {(inputs: _Field_Enum_Icsrm_Fra8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt University of Applied Sciences`)
};

/**
* | output |
* | --- |
* | "Frankfurt University of Applied Sciences" |
*
* @param {_Field_Enum_Icsrm_Fra8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_fra8 = /** @type {((inputs?: _Field_Enum_Icsrm_Fra8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Fra8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_fra8(inputs)
	return de__field_enum_icsrm_fra8(inputs)
});
export { _field_enum_icsrm_fra8 as "_field_enum_ICSRM_FRA" }